module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAAo0lEQVQ4T2MMDQ3lfPX86eX/DP+VGRkY8w8eOTaJgQRgb2OV95/h/0RGBsa7YpLSuowgvQ521un//v2bzsDAwEiKoTDDGBgY/jMxMWUeOHR0JthAcgzFZhjIHLiBpBiKyzAMA4kxFJ9hWA3EZyghw3AaiM1QkBgoNpEjAFtiQAlDdAXIsQ+Vg8cmrpSF10A0lzLAkga+ZErQQJihIBqUzgileQAeJYATsYtRRAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/home_icon_xjt@2x.png
// module id = pgTg
// module chunks = 0